import styled from 'styled-components'

export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
  }
`
